import type { ButtonSize } from '../Button/types';

/** Chevron icon size per button size. */
export const chevronIconSize: Record<ButtonSize, number> = {
  S: 10,
  M: 10,
  L: 12,
};

/** Default trigger aria-label. */
export const DEFAULT_TRIGGER_ARIA_LABEL = 'More options';
